import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Duyệt đơn (Approve.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'meeAp.approvedN': 'Đã duyệt {n} đơn',
  'meeAp.rejectedN': 'Đã từ chối {n} đơn',
  'meeAp.hSender': 'Người gửi',
  'meeAp.hTime': 'Thời gian',
  'meeAp.hQty': 'Số lượng',
  'meeAp.hHand': 'Bàn giao',
  'meeAp.hLeft': 'Phép còn',
  'meeAp.hStatus': 'Trạng thái',
  'meeAp.rejectAria': 'Từ chối {id} của {who}',
  'meeAp.approveAria': 'Duyệt {id} của {who}',
  'meeAp.reject': 'Từ chối',
  'meeAp.approve': 'Duyệt',
  'meeAp.title': 'Duyệt đơn của nhóm',
  'meeAp.pickOne': 'Chọn ít nhất một đơn để duyệt',
  'meeAp.approveSelN': 'Duyệt đã chọn ({n})',
  'meeAp.approveSel': 'Duyệt đã chọn',
  'meeAp.absence': 'Lịch vắng của nhóm',
  'meeAp.kLeave': 'Nghỉ phép',
  'meeAp.kTrip': 'Công tác',
  'meeAp.kWait': 'Chờ duyệt',
  'meeAp.kToday': 'Hôm nay',
  'meeAp.pendingList': 'Đơn chờ duyệt',
  'meeAp.none': 'Không có đơn chờ duyệt',
  'meeAp.seat': 'Duyệt với ghế [{seat}]',
  'meeAp.rejReq': 'Từ chối đơn {id}',
  'meeAp.rejReq0': 'Từ chối đơn',
  'meeAp.reasonTo': 'Lý do gửi tới {who}',
  'meeAp.cancel': 'Huỷ',
  'meeAp.reason': 'Lý do',
  'meeAp.needReason': 'Cần nhập lý do',
  'meeAp.rejPh': 'Trùng cao điểm cut-off, đề nghị đổi ngày',
});
addMessages('en', {
  'meeAp.approvedN': 'Approved {n} requests',
  'meeAp.rejectedN': 'Rejected {n} requests',
  'meeAp.hSender': 'Sender',
  'meeAp.hTime': 'Time',
  'meeAp.hQty': 'Quantity',
  'meeAp.hHand': 'Handover',
  'meeAp.hLeft': 'Leave left',
  'meeAp.hStatus': 'Status',
  'meeAp.rejectAria': 'Reject {id} from {who}',
  'meeAp.approveAria': 'Approve {id} from {who}',
  'meeAp.reject': 'Reject',
  'meeAp.approve': 'Approve',
  'meeAp.title': 'Team request approval',
  'meeAp.pickOne': 'Select at least one request to approve',
  'meeAp.approveSelN': 'Approve selected ({n})',
  'meeAp.approveSel': 'Approve selected',
  'meeAp.absence': 'Team absence calendar',
  'meeAp.kLeave': 'Leave',
  'meeAp.kTrip': 'Business trip',
  'meeAp.kWait': 'Pending',
  'meeAp.kToday': 'Today',
  'meeAp.pendingList': 'Requests awaiting approval',
  'meeAp.none': 'No requests awaiting approval',
  'meeAp.seat': 'Approving as seat [{seat}]',
  'meeAp.rejReq': 'Reject request {id}',
  'meeAp.rejReq0': 'Reject request',
  'meeAp.reasonTo': 'Reason will be sent to {who}',
  'meeAp.cancel': 'Cancel',
  'meeAp.reason': 'Reason',
  'meeAp.needReason': 'A reason is required',
  'meeAp.rejPh': 'Clashes with cut-off peak, please change the date',
});
